import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "@/App";
import { applyStoredDensity } from "@/hooks/useDensity";
import "@/index.css";

// 저장된 표 밀도를 첫 렌더 전에 건다 — 나중에 걸면 기본 밀도로 한 번 그려진 뒤 표가 튄다.
applyStoredDensity();

const container = document.getElementById("root");
if (!container) {
  throw new Error("#root 엘리먼트를 찾을 수 없습니다.");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>
);
